<template>
    <div class="prize-settings-section">
        <div class="page-title">
            <h4> {{$t('txt.setariPremii')}}</h4>
        </div>
        <div class="prize-settings-wrapper">
            <p> {{$t('txt.punctFidelitate', {point_value})}} </p>
        </div>
        <form id="prize-settings-form">
            <div class="prize-setup">
                <span> {{$t('txt.seteazaValoarePunct')}} </span>
                <input type="number" v-model="point_value" name="amount" min="1" max="100">
            </div>
            <div class="save-prize-settings">
                <button @click.prevent="savePrizeSettings()">
                    <i class="far fa-save"></i>
                    {{$t('txt.salveazaSetari')}}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import PrizesService from '../../api-services/prizes.service.js'
export default {
  name: 'prizesettings',
  data () {
    return {
      point_value: null
    }
  },
  methods: {
    savePrizeSettings () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('prize-settings-form'))
      PrizesService.prizesSettings(formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.modificariSucces'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            window.scrollTo(0, 0)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
          this.$store.dispatch('hideLoading')
        })
    },
    getPrizeSettings () {
      this.$store.dispatch('showLoading')
      PrizesService.getPrizesSettings()
        .then((response) => {
          this.$store.dispatch('showLoading')
          if (response.data.data) {
            this.point_value = response.data.data[1]
          }
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            window.scrollTo(0, 0)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.getPrizeSettings()
  }
}
</script>
